import CryptoJS from 'crypto-js';
function generate(requestPart, key, payloadPart = '<BLANK>') {
  const plainText = requestPart + ':' + payloadPart;

  const secretKey = CryptoJS.SHA256(key);
  const hash = CryptoJS.HmacSHA256(CryptoJS.enc.Utf8.parse(plainText), secretKey);
  const securedData = CryptoJS.enc.Base64.stringify(hash); // string: 'NzUzMjI1NDE='

  return securedData;
}

function verify(authHeader, requestPart, key, payloadPart = '<BLANK>') {
  return generate(requestPart, key, payloadPart) === authHeader;
}

export { generate, verify };
